import { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { HelmetProvider } from "react-helmet-async";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Community from "./pages/Community";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import JobApplication from "./pages/JobApplication";

import { Link } from "react-router-dom";

function HiddenLinksForReactSnap() {
  return (
    <div style={{ display: "none" }}>
      <Link to="/">Home</Link>
      <Link to="/community">Community</Link>
      <Link to="/contact">Contact</Link>
      <Link to="/careers">Careers</Link>
    </div>
  );
}

export function App() {
  const [selectedItems, setSelectedItems] = useState("Home");

  return (
    // <HelmetProvider>
    <Router>
      <div>
        <Navbar
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
        />

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/community" element={<Community />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/job-application" element={<JobApplication />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
    // </HelmetProvider>
  );
}

export default App;
